<template>

    <div class="card p-3 mb-5">
        <div class="d-flex align-items-center justify-content-start gap-3 px-3">
            <button @click="onBack" class="btn btn-back p-0">
                <span class="svg-icon svg-icon-2">
                    <inline-svg src="/media/icons/duotune/arrows/arr021.svg"/>
                </span>
                <span>{{ $t('common.back') }}</span>
            </button>
            <div>|</div>
            <h2 class="fs-2 fw-bold my-2">
                <template v-if="userID">
                    {{ sprintf($t('pages.user.editUserPattern'), [user.full_name ?? '']) }}
                </template>
                <template v-else>{{ $t('pages.user.newUser') }}</template>
            </h2>
        </div>
    </div>

    <el-form :model="form.data" ref="userForm">
        <div class="row g-6 mb-6 g-xl-9 mb-xl-9">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-body d-flex flex-column p-9">
                        <div class="row">
                            <div class="col-md-6 fv-row mb-1">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.user.cols.firstname') }}</label>
                                <el-form-item prop="firstname" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.firstname" type="text"/>
                                </el-form-item>
                            </div>
                            <div class="col-md-6 fv-row mb-1">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.user.cols.lastname') }}</label>
                                <el-form-item prop="lastname" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.lastname" type="text"/>
                                </el-form-item>
                            </div>

                            <div class="col-md-6 fv-row mb-1">
                                <label class="required fs-6 fw-bold mb-2">{{
                                        $t('pages.user.cols.mobilePhone')
                                    }}</label>
                                <el-form-item prop="mobile_phone" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.mobile_phone" type="phone"/>
                                </el-form-item>
                            </div>

                            <div class="col-md-6 fv-row mb-1">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.user.cols.email') }}</label>
                                <el-form-item prop="email">
                                    <el-input v-model="form.data.email" type="email"/>
                                </el-form-item>
                            </div>

                            <template v-if="(!userID)">
                                <div class="col-md-6 fv-row mb-1">
                                    <label class="required fs-6 fw-bold mb-2">{{ $t('pages.user.cols.password') }}</label>
                                    <el-form-item prop="password" :rules="$validation.getMessage(['required'])">
                                        <el-input v-model="form.data.password" type="text"/>
                                    </el-form-item>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card">
                    <div class="card-body d-flex flex-column p-9">
                        <div class="fv-row mb-1">
                            <label class="required fs-6 fw-bold mb-2">{{ $t('pages.user.cols.role') }}</label>
                            <el-form-item prop="labels">
                                <el-select v-model="form.data.roles" class="w-100"
                                           :placeholder="$t('common.chooseSelect')" filterable multiple>
                                    <el-option v-for="(item, itemIndex) in types" :key="itemIndex" :value="item.id"
                                               :label="item.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="fv-row mt-5">
                            <el-form-item class="mb-0">
                                <button @click.prevent="onSubmit" :data-kt-indicator="form.loading ? 'on' : null"
                                        class="btn btn-lg btn-primary w-100" type="button">
                                    <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                                    <span v-if="form.loading" class="indicator-progress">
                                                {{ $t("messages.wait") }}
                                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                </button>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
export default {
    name: "_id",
    components: {},
    data() {
        return {
            tabModel: 'general',
            user: {},
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {
                    firstname: null,
                    lastname: null,
                    email: null,
                    mobile_phone: null,
                    password: null,
                    roles: []
                },
            },
            rules: {}
        }
    },
    computed: {
        userID() {
            return this.$route.params.id;
        },
        types() {
            return this.$store.state.user.role.table.data;
        }
    },
    created() {
        if (this.userID && !(this.userID > 0)) {
            this.$router.push({
                path: "/user"
            });
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.userManagement"), []);

        this.$store.dispatch('user/role/get', {
            page: {
                pageSize: 9999
            }
        });

        if (this.userID && this.userID > 0) {
            this.loadUser();
        }
    },
    watch: {
        userID(newValue) {
            if (newValue && newValue > 0) {
                this.form.updateStatus = true;
                this.loadUser(newValue);
            } else {
                this.tabModel = 'general';
                this.form.updateStatus = false;
                this.form.data = {
                    firstname: null,
                    lastname: null,
                    email: null,
                    mobile_phone: null,
                    password: null,
                    roles: []
                };
                this.user = {};
            }
        }
    },
    methods: {
        onBack() {
            this.$router.push({
                path: "/user"
            });
        },
        loadUser(userID = this.userID) {
            this.axios.get(this.endpoints['user'] + '/' + userID).then((response) => {
                let data = response.data.data;
                this.user = data;

                data.roles = data.roles.map((item) => {
                    return item.id;
                });

                this.form.updateStatus = true;
                this.form.data = Object.assign(data);
            });
        },
        onSubmit() {
            this.$refs.userForm.validate((valid) => {
                if (valid) {
                    this.form.loading = true;

                    if (this.form.data.id) {
                        this.axios.put(this.endpoints['user'] + '/' + this.form.data.id, this.form.data).then(response => {
                            this.onResponse(response.data, () => {
                                this.loadUser();
                            }, () => {
                                this.form.loading = false;
                            });
                        }).catch(error => {
                            this.onResponseFailure(error.response.data, () => {
                                this.form.loading = false;
                            });
                        });
                    } else {
                        this.axios.post(this.endpoints['user'], this.form.data).then(response => {
                            this.onResponse(response.data, () => {
                                let userID = response.data.data.id;
                                this.$router.push({
                                    path: "/user/save/" + userID
                                });

                                this.loadUser(userID);
                            }, () => {
                                this.form.loading = false;
                            });
                        }).catch(error => {
                            this.onResponseFailure(error.response.data, () => {
                                this.form.loading = false;
                            });
                        });
                    }
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}
</style>